import { defineComponent as _defineComponent } from 'vue'
import BButton from '../BButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BButtonSubmitButton',
  setup(__props) {


return { __sfc: true,BButton }
}

})